import { PrevisaoProducaoState } from '../../types/state.types';
import { getMonthRange } from '../../utils/functions-helper';
import { StoreAction } from '../reduxTypes';
import * as actions from './actions';

const [dataInicial, dataFinal] = getMonthRange();

const initialState: PrevisaoProducaoState = {
  requisitado: false,
  filtros: {
    dataInicio: dataInicial,
    dataFim: dataFinal,
    setorId: undefined,
    lotacaoId: undefined,
  },
  filtrosBuscados: {
    dataInicio: dataInicial,
    dataFim: dataFinal,
  },
  listaLotacoes: [],
  listaSetores: [],
  dadosProducao: undefined,
  loading: false,
}

const  reducer = (
  state: PrevisaoProducaoState = initialState,
  action: StoreAction,
): PrevisaoProducaoState => {
  switch (action.type) {
    // case actions.PREVISAO_PRODUCAO__START_LOADING:
    //   return {
    //     ...state,
    //     requisitado: true,
    //   }
    
    // case actions.PREVISAO_PRODUCAO__STOP_LOADING:
    //   return {
    //     ...state,
    //     requisitado: false,
    //   }
    
    case actions.PREVISAO_PRODUCAO__INICIALIZA_ESTADO:
      return {
        ...state,
        requisitado: true,
      }
    
    case actions.PREVISAO_PRODUCAO__SET_SETORES:
      return {
        ...state,
        listaSetores: [
          {Nome: ' Todos', ID: 0},
          ...action.payload
        ],
      }
    
    case actions.PREVISAO_PRODUCAO__SET_LOTACOES:
      return {
        ...state,
        listaLotacoes: [
          {Nome: ' Selecionar Lotação', ID: 0},
          ...action.payload
        ],
      }
    
    case actions.PREVISAO_PRODUCAO__SET_DADOS_PREVISAO:
      return {
        ...state,
        dadosProducao: action.payload,
      }

    case actions.PREVISAO_PRODUCAO__SET_FILTROS:
      return {
        ...state,
        filtros: action.payload,
        dadosProducao: initialState.dadosProducao,
      }

    case actions.PREVISAO_PRODUCAO__SET_FILTROS_BUSCA:
      return {
        ...state,
        filtrosBuscados: action.payload,
      }

    case actions.PREVISAO_PRODUCAO__LIMPAR_FILTROS:
      return {
        ...state,
        filtros: initialState.filtros,
      }

    case actions.PREVISAO_PRODUCAO__SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
  
    case 'SESSION__LOGOUT':
      return initialState;
  
    default:
      return state;
  }
}

export default reducer;
